<script lang="ts">
	import Spinner from '$lib/components/Spinner/Spinner.svelte';
	export let loading = false;
</script>

{#if loading}
	<Spinner />
{:else}
	<slot />
{/if}
